import { defineTokens } from '@chakra-ui/react';

export const lineHeights = defineTokens.lineHeights({
  /*
    Строка высотой в кегль: значок, бейдж, галочка статуса, стрелка пагинации. Это не
    типографика, а выравнивание - у элемента одна строка, и лишний воздух над ней сдвигает его
    с оси соседей. Тринадцать мест писали это числом `1`; имя то же, что у Chakra по умолчанию.
  */
  none: {
    value: 1,
  },
  shorter: {
    value: 1.25,
  },
  short: {
    value: 1.375,
  },
  moderate: {
    value: 1.5,
  },
  tall: {
    value: 1.625,
  },
  taller: {
    value: 2,
  },
});
